export const clearStores = (redirectUrl: string) => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.clear();
    window.location.href = redirectUrl;
};
